import { Card } from '@sainsburys-tech/luna-card'
import { Body1 } from '@sainsburys-tech/luna-typography'
import {
  Title,
  IncidentInvolved,
  IncidentDescription,
  ReportedByDescription
} from '../Components'
import { IIncident } from '../../../types'
import getIncidentCategory from '../../../utils/getIncidentCategory'

const IncidentCard = ({ incident }: IIncident) => {
  const incidentCategory = getIncidentCategory({incident:incident})
  const incidentCategoryText = incidentCategory ? (' - ' + incidentCategory) : ''

  const fraudDetails = incident.incidentType === 'SuspectedFraud' ? {
    location: incident.fraudLocation ? convertFraudLocation(incident.fraudLocation) : null,
    suspectedFraudType: incident.suspectedFraudType ? convertSuspectedFraudType(incident.suspectedFraudType) : null,
    fraudType: incident.fraudType ?? null
  } : null

  return (
    <Card className="s-reported-accident-card rln-c-card ln-c-card--soft ln-u-margin-bottom*2 ln-u-margin-left">
      <></>
      <Title
        text={convertIncidentType(incident.incidentType).replaceAll('_', ' ') + (incidentCategoryText) } 
      />
      <Body1
          className="ln-u-color-dark"
          id="colleagueFriendlyId_SEC-1"
        >
          {incident.serviceNowReferenceNumber}
        </Body1>
      <IncidentDescription
        dateOfIncident={incident.incidentDate ? new Date(`${incident.incidentDate}.000Z`) : null}
        timeOfIncident={new Date(`${incident.incidentDate}.000Z`) ?? null}
        location={incident.onSiteLocation ? incident.onSiteLocation : null }
        store={incident.locationFriendlyName ? incident.locationFriendlyName : null}
        type={"incident"}
        fraudDetails={fraudDetails}
      />
      <IncidentInvolved
        totalPeople={incident.people ? incident.people.length : 0}
        totalVehicles={incident.vehicles ? incident.vehicles.length : 0}
        affectedProducts={incident.affectedProducts}
      />
      <ReportedByDescription 
        reportedBy={incident.addedByName ? incident.addedByName : ''}
        dateReported={new Date(`${incident.addedAt}.000Z`)}
        timeReported={new Date(`${incident.addedAt}.000Z`)}
      />
    </Card>
  )
}

const convertIncidentType = (incidentType: string) => {
  switch(incidentType) {
    case 'VerbalAbuse':
      return 'Verbal abuse'
    case 'AntisocialBehaviour':
      return 'Antisocial behaviour'
    case 'SuspectedFraud':
      return 'Suspected fraud'
    case 'ProblemWithDeliverySeal':
      return 'Problem with delivery seal'
    case 'Theft':
      return 'Theft'
    case 'ColleagueTheft':
      return 'Colleague theft'
    default:
      return 'Unknown'
  }
}

const convertSuspectedFraudType = (suspectedFraudType: string) => {
  switch(suspectedFraudType) {    
    case 'Refunds':
    case 'Process':
    case 'Reductions':
    case 'Coupons':
    case 'Other':
    case 'GOL':
    case 'Order':
      return suspectedFraudType
    case 'SmartShop':
      return 'Smart Shop'
    case 'ColleagueDiscount':
      return 'Colleague Discount'
    case 'GiftCards':
      return 'Gift Cards'
    case 'IncorrectItemReturn':
      return 'Incorrect Item Return'
    case 'FraudulentRedemptions':
      return 'Fraudulent redemptions'
    case 'SuspiciousActivity':
      return 'Suspicious activity'
    case 'PotentialBreachCardMisuse':
      return 'Potential Breach/Card Misuse'
    default:
      return 'Unknown'
  }
}

const convertFraudLocation = (fraudLocation: string) => {
  switch(fraudLocation) {
    case 'Online':
      return 'Online'
    case 'Instore':
      return 'In-Store'
    default:
      return ''
  }
}

export default IncidentCard
